type Callback = (data: object | string | undefined) => void
type CallhandlerOption = object | undefined

// Extend the Window interface to include WebViewJavascriptBridge
declare global {
  interface Window {
    WebViewJavascriptBridge?: {
      registerHandler: (action: string, callback: Callback) => void;
      callHandler: (type: string, option: CallhandlerOption, callback: Callback) => void;
    };
  }
}

const onWebViewJavascriptBridgeReady = (callback: Callback) => {
  document.addEventListener('WebViewJavascriptBridgeReady', () => {
    const { WebViewJavascriptBridge } = window
    if (WebViewJavascriptBridge) {
      console.log('js bridge ready')
      if (callback) {
        callback(WebViewJavascriptBridge);
      }
    } else {
      console.warn('WebViewJavascriptBridge not found, this is a mock function (registerHandler)')
    }
  })
}

const jsBridge = {
  registerHandler: (action: string, callback: Callback) => {
    console.log('jsBridge registerHandler: ', action)
    const { WebViewJavascriptBridge } = window
    if (WebViewJavascriptBridge) {
      (WebViewJavascriptBridge as NonNullable<Window['WebViewJavascriptBridge']>).registerHandler(action, callback)
    } else {
      onWebViewJavascriptBridgeReady((WebViewJavascriptBridge) => {
        if (WebViewJavascriptBridge) {
          (WebViewJavascriptBridge as NonNullable<Window['WebViewJavascriptBridge']>).registerHandler(action, callback)
        }
      })
    }
  },
  callHandler: (type: string, option: CallhandlerOption, callback: Callback) => {
    console.log('jsBridge callHandler: ', type, option)
    const { WebViewJavascriptBridge } = window
    if (WebViewJavascriptBridge) {
      return WebViewJavascriptBridge.callHandler(type, option, callback)
    } else {
      onWebViewJavascriptBridgeReady((WebViewJavascriptBridge) => {
        if (WebViewJavascriptBridge) {
          (WebViewJavascriptBridge as NonNullable<Window['WebViewJavascriptBridge']>).callHandler(type, option, callback)
        }
      })
    }
  }
}

export default jsBridge
